import { base } from '../base';

export const baseODATA = 'gateway/mainodata';

export const contact = `${base}/Contact`;
export const getQueryODATA = `${baseODATA}/contactsearchquery`;
